import React from 'react';
// import ReactDOM from 'react-dom';

const heading=(props)=>{
    return (
        <div>
            <h1>Whats is the weather like ?</h1>
            <h3>Find out what the weather condition in your city?</h3>
        </div>
    );
}
export default  heading ;